import React, { useEffect } from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"

import {
  springVariants,
  delayedSpringVariants,
  opacityVariants,
  springViewport,
} from "../utils/framerVariants";

const ArticleCard = ({ article }) => {

  const isVideo = article.cover?.mime?.startsWith("video")
  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de');
  // Guard against missing video cover
  const videoUrl = article.videocover?.file?.url;

  return (
    <motion.div
      variants={springVariants}
      initial="invisible"
      whileInView="visible"
      viewport={springViewport}
      className="col-span-1 articleCard"
    >

      <Link
        to={`/${isGerman ? 'de/' : ''}${article.slug}`}
      >
        {isVideo && videoUrl ? (
          <div
            dangerouslySetInnerHTML={{
              __html: `<video class="allianz-player aspect-foundation object-cover h-full w-full" playsinline autoplay loop muted><source src="${article.videocover.file.url}" type="video/mp4" /></video>`
            }}
          />
        ) : (
          <GatsbyImage
            className="aspect-foundation"
            image={getImage(article?.cover?.file)}
            alt={article?.cover?.alternativeText || ""}
          />
        )}
      </Link>

      <div className="flex gap-x-4 gap-y-1 mt-6 pr-24 md:pr-56 flex-wrap">
        {article.tags && article.tags.map((tag, i) => (
          <Link
            to={`/${isGerman ? 'de/' : ''}${tag.slug}`}
            title={tag.name}
            key={i}
            className="tags font-semibold lowercase">
            <span className="text-tags tracking-text leading-text font-semibold">{tag.name}</span>
          </Link>
        ))}
      </div>

      <Link to={`/${isGerman ? 'de/' : ''}${article.slug}`} className="xl:max-w-xl 2xl:max-w-2xl block max-w-none md:max-w-md lg:max-w-lg">
        <h2 className="pr-12 mb-6 text-headline-md tracking-headline-md leading-headline-md font-bold mt-6">{article.title}</h2>
        <p className="pr-12">{article.description}</p>
      </Link>

    </motion.div>
  )
}

export const query = graphql`
  fragment ArticleCard on StrapiArticle {
    id
    slug
    title
    description
    tags {
      name
      slug
    }
    videocover: cover {
      caption
      name
      mime
      alternativeText
      file {
        url
      }
    }
    cover {
      caption
      name
      mime
      alternativeText
      file {
        url
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  }
`
export default ArticleCard
